import React from 'react';
import PropTypes from 'prop-types';
import { Drawer } from '@knockrentals/knock-shared-web-v2';

export const FeatureDrawer = ({ children, closeDrawer, isOpen, title }) => (
  <Drawer
    anchor="right"
    denseHeader
    onClose={closeDrawer}
    open={isOpen}
    size="small"
    title={title}
    variant="temporary"
  >
    {children}
  </Drawer>
);

FeatureDrawer.propTypes = {
  children: PropTypes.node,
  closeDrawer: PropTypes.func,
  isOpen: PropTypes.bool,
  title: PropTypes.string,
};
